import type { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { InfoSidebarModal } from '~/features/leadDetails/components/BankCreditRequest/InfoSidebarModal';
import { CreditWorthiness } from '~/features/leadDetails/components/BankCreditRequest/NewCreditRequest/RequestConfiguration/OfferExtraInfo/CreditWorthiness';
import type { AcceptedOfferSource } from '~/features/leadDetails/components/BankCreditRequest/NewCreditRequest/RequestConfiguration/types';

type CreditWorthinessOffer = Extract<
    AcceptedOfferSource,
    { source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE | typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC }
>;

type DialogProps = CreditWorthinessOffer & {
    isOpen: boolean;
    onClose: () => void;
};

export const CreditWorthinessDialog = ({ isOpen, onClose, ...acceptedOffer }: DialogProps) => {
    const { t } = useTranslation();

    return (
        <InfoSidebarModal
            title={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.HOUSEHOLD_CALCULATION')}
            open={isOpen}
            onClose={onClose}
            testId="offerExtraInfoDialog"
        >
            <CreditWorthiness householdBudget={acceptedOffer.offer?.bonitaetsrechnung} showTitle={false} />
        </InfoSidebarModal>
    );
};
